import {
  Component,
  Input,
  PLATFORM_ID,
  OnInit,
  Inject,
  SimpleChanges,
  ElementRef,
  Renderer2,
  ViewChild,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';

import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss'],
  standalone: false,
})
export class TestimonialsComponent implements OnInit, OnDestroy {
  @ViewChild('imageElement') imageElement!: ElementRef<HTMLImageElement>;
  @ViewChild('imageContainer') imageContainer!: ElementRef<HTMLDivElement>;

  @Input() testimonials: any = {};
  @Input() textColor: any = '';
  @Input() backgroundColor: any = '';

  isBrowser: boolean = false;

  reviews: any = [];
  currentIndex: number = 0;
  currentReview: any = null;
  mainColor: any = '';
  mainBackgroundColor: any = '';
  timer: any;
  countdownTimer: any;
  // countdownValue: number = 0;
  showFullDescription: boolean = false;

  mainTimer = 15;
  countdownValue: number | null = null;
  private mainInterval: any;
  private countdownInterval: any;
  circumference = 2 * Math.PI * 25;

  constructor(
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  defaultReviews = [];

  ngOnInit(): void {
    this.setReviews();
    this.mainColor = this.textColor;
    this.mainBackgroundColor = this.backgroundColor;
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.isBrowser) {
      const textElement = document.querySelector(
        '.director-message'
      ) as HTMLElement;
      const imageElement = document.querySelector('.image') as HTMLElement;

      if (textElement && imageElement) {
        textElement.addEventListener('mouseenter', () => this.pauseTimer());
        textElement.addEventListener('mouseleave', () => this.resumeTimer());
        imageElement.addEventListener('mouseenter', () => this.pauseTimer());
        imageElement.addEventListener('mouseleave', () => this.resumeTimer());
      }

      this.startTimer();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['school'] && changes['school'].currentValue) {
      this.setReviews();
      this.mainColor = this.textColor;
      this.mainBackgroundColor = this.backgroundColor;
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
  }

  adjustBackLayer(): void {
    if (this.isBrowser) {
      const image = this.imageElement.nativeElement;
      const container =
        this.imageContainer.nativeElement.querySelector('.back-layer');

      if (image && container) {
        const { width, height } = image.getBoundingClientRect();
        this.renderer.setStyle(container, 'width', `${width}px`);
        this.renderer.setStyle(container, 'height', `${height}px`);
      }
    }
  }

  setReviews(): void {
    this.reviews = this.testimonials;

    this.currentReview = this.reviews[this.currentIndex];
  }

  nextReview() {
    this.currentIndex = (this.currentIndex + 1) % this.reviews.length;
    this.currentReview = this.reviews[this.currentIndex];
    this.resetTimer();
    this.showFullDescription = false;
  }

  previousReview() {
    this.currentIndex =
      (this.currentIndex - 1 + this.reviews.length) % this.reviews.length;
    this.currentReview = this.reviews[this.currentIndex];
    this.resetTimer();
    this.showFullDescription = false;
  }

  startTimer() {
    if (this.isBrowser) {
      this.timer = setInterval(() => {
        this.nextReview();
      }, 15000);
    }
  }

  // startTimer() {
  //   if (this.isBrowser) {
  //     this.clearTimers();
  //     this.mainTimer = 15;
  //     console.log(this.mainTimer);
  //     this.mainInterval = setInterval(() => {
  //       this.mainTimer--;

  //       if (this.mainTimer === 5) {
  //         console.log(this.mainTimer);
  //         this.startCountdown();
  //       }

  //       if (this.mainTimer <= 0) {
  //         this.nextItem();
  //         this.mainTimer = 15;
  //       }
  //     }, 1000);
  //     this.timer = setInterval(() => {
  //       this.nextReview();
  //     }, 15000);
  //   }
  // }

  startCountdown() {
    this.countdownValue = 5;

    this.countdownInterval = setInterval(() => {
      if (this.countdownValue) {
        this.countdownValue--;
        console.log(this.countdownValue);
        if (this.countdownValue <= 0) {
          clearInterval(this.countdownInterval);
          this.countdownValue = null;
          console.log(this.countdownInterval);
        }
      }
    }, 1000);
  }

  getDashOffset(): number {
    if (!this.countdownValue) return 0;
    return this.circumference - (this.countdownValue / 5) * this.circumference;
  }

  clearTimers() {
    clearInterval(this.mainInterval);
    clearInterval(this.countdownInterval);
  }

  nextItem() {
    this.clearTimers();
    this.countdownValue = null;
    this.startTimer();
    // Add your navigation logic here
  }

  previousItem() {
    this.clearTimers();
    this.countdownValue = null;
    this.startTimer();
    // Add your navigation logic here
  }

  pauseTimer() {
    if (this.isBrowser) {
      clearInterval(this.timer);
      clearInterval(this.countdownTimer);
    }
  }

  resumeTimer() {
    this.resetTimer();
  }

  resetTimer() {
    if (this.isBrowser) {
      clearInterval(this.timer);
      this.pauseTimer();
      this.startTimer();
    }
  }

  toggleDescription() {
    this.showFullDescription = !this.showFullDescription;
  }

  handleDescription(description: string): string {
    // const words = description.split(' ');
    // if (words.length > 10 && !this.showFullDescription) {
    //   return words.slice(0, 10).join(' ') + '...';
    // }
    if (description.length > 50 && !this.showFullDescription)
      return description.slice(0, 50) + '...';
    return description;
  }
}
